import { filter, map } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { selectCoopLevelFromXp } from "../../../selectors/selectCoopInfo";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { PlayerPreferencesPlatformType } from "../../../utils/network/generated/protoTypes";
import { utilPersistence } from "../../../utils/utilPersistence";
import { TypeActionCoopInfo } from "../../cooperative/actionCoop";
import { actionServerPersistenceSetInfo, } from "../actionServerPersistence";
var coopLevelNeedsOverride = function (state) { return function (action) {
    var typeMatches = action.type === TypeActionCoopInfo.Received;
    var isOwnCoop = action.coop !== undefined &&
        action.coop.id !== undefined &&
        selectPlayerInfo(state).coopId !== undefined &&
        selectPlayerInfo(state).coopId.equals(action.coop.id);
    var previousValue = utilPersistence.getValue(IdPersistence.CoopPreviousLevel);
    var isXpAvailable = action.coop !== undefined && action.coop.xp !== undefined;
    return (typeMatches &&
        isXpAvailable &&
        isOwnCoop &&
        (previousValue === undefined || previousValue === Number.MAX_VALUE));
}; };
export var epicSetPreviousCoopLevel = function (action$, state$, deps) {
    return action$.pipe(filter(coopLevelNeedsOverride(state$.value)), map(function (action) {
        var leagueLevel = selectCoopLevelFromXp(action.coop.xp);
        var valueToSet = {
            key: IdPersistence.CoopPreviousLevel,
            platform: PlayerPreferencesPlatformType.PLAT_SHARED,
            value: leagueLevel.toString(),
        };
        return actionServerPersistenceSetInfo(valueToSet);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/server-persistence/epics/epicSetPreviousCoopLevel.ts
// module id = 2329
// module chunks = 3